module.exports = __webpack_public_path__ + "img/CR.702696fd.svg";